module.exports = __webpack_public_path__ + "static/media/Global-Mentorship.17fd688c.svg";